import * as React from "react";
import { ProductBlockGallery } from "@grandvisionhq/lib-visuals";
import { getRecommendationKey } from "../../../../../../utils/lib-components/RecommendedProducts/utils/get-recommendation-key.js";
import { BannerRecommendationBlock } from "../../../../../BannerRecommendationBlock/lib-components/RecommendedProducts/components/BannerRecommendationBlock/BannerRecommendationBlock.js";
import { ProductRecommendationBlock } from "../../../../../ProductRecommendationBlock/lib-components/RecommendedProducts/components/ProductRecommendationBlock/ProductRecommendationBlock.js";
const RecommendationsGallery = ({
  recommendations,
  itemsPerSlide,
  navigationLocation,
  shouldRenderBlocksAsCards
}) => {
  const renderBlock = ({ blockKey, className, tabIndex }) => {
    const recommendationIndex = recommendations.findIndex((recommendation2) => {
      const key = getRecommendationKey(recommendation2);
      return blockKey === key;
    });
    const recommendation = recommendations[recommendationIndex];
    if (!recommendation) {
      return null;
    }
    if (recommendation.recommendationType === "banner") {
      return /* @__PURE__ */ React.createElement(
        BannerRecommendationBlock,
        {
          key: blockKey,
          className,
          recommendation,
          shouldRenderAsCard: shouldRenderBlocksAsCards,
          tabIndex
        }
      );
    }
    return /* @__PURE__ */ React.createElement(
      ProductRecommendationBlock,
      {
        key: blockKey,
        className,
        recommendation,
        shouldRenderAsCard: shouldRenderBlocksAsCards,
        position: recommendationIndex + 1,
        tabIndex
      }
    );
  };
  const blockKeys = recommendations.map(getRecommendationKey);
  return /* @__PURE__ */ React.createElement(
    ProductBlockGallery,
    {
      isLoading: false,
      hasError: false,
      blockKeys,
      renderBlock,
      itemsPerSlide,
      navigationLocation
    }
  );
};
export {
  RecommendationsGallery
};
//# sourceMappingURL=RecommendationsGallery.js.map
